module.exports = __webpack_public_path__ + "images/thumb-d4433c947ec1ec41e13c60da1179776e.jpg";